/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Theme, Tooltip, useTheme } from 'bold-ui'

interface ButtonAcessoRndsProps {
  disabled: boolean
  onClick: () => void
}

export const ButtonAcessoRnds = (props: ButtonAcessoRndsProps) => {
  const { disabled, onClick } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Tooltip
      text={disabled && 'Não é possível visualizar os registros na RNDS de cidadãos que não possuem CNS cadastrado'}
    >
      <Button kind='primary' size='medium' style={styles.button} onClick={onClick} disabled={disabled}>
        <div css={styles.divSpan}>
          <span>SUS Digital </span>
          <span css={styles.profissionalText}>Profissional</span>
        </div>
      </Button>
    </Tooltip>
  )
}

const createStyles = (theme: Theme) => ({
  button: css`
    padding: 0.3rem 1rem;
    line-height: 1.2rem;
  `,
  profissionalText: css`
    display: block;

    ${theme.breakpoints.up('lg')} {
      display: inline;
    }
  `,
  divSpan: css`
    display: block;
  `,
})
